import type { ParsedLocation } from '@tanstack/react-router';
import { redirect } from '@tanstack/react-router';
import type { USER_ROLES } from 'cpool-constants';
import type { ValueOf } from 'cpool-utils';

import { useUserStore } from '~/store/userStore';

export const authoriseUser = (roles: Array<ValueOf<typeof USER_ROLES>>, location: ParsedLocation<object>) => {
    const { user } = useUserStore.getState();
    if (!user) {
        throw redirect({ search: { redirect: location.href }, to: '/login' });
    }
    if (!user?.role || !roles.includes(user.role as ValueOf<typeof USER_ROLES>)) {
        throw redirect({ to: '/accessdenied' });
    }
};
